module.exports = __webpack_public_path__ + "img/modal-ed3.bf2494a5.png";